import { FaClock } from 'react-icons/fa6'
import AnimatedSection from '../common/AnimatedSection'
import { contactBusinessHours } from '../../data/contactPageData'

function ContactBusinessHours() {
  const { title, schedule } = contactBusinessHours

  return (
    <AnimatedSection className="contact-hours">
      <div className="container corp-container">
        <div className="contact-hours__bar">
          <div className="contact-hours__brand">
            <span className="contact-hours__icon" aria-hidden="true">
              <FaClock />
            </span>
            <strong>{title}</strong>
          </div>

          {schedule.map((slot) => (
            <div className="contact-hours__slot" key={slot.label}>
              <span className="contact-hours__day">{slot.label}</span>
              <span className={slot.closed ? 'contact-hours__time contact-hours__time--closed' : 'contact-hours__time'}>
                {slot.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default ContactBusinessHours
